import React from "react";
import { Link } from "react-router-dom";

function ExternalTabLink({
  to,
  target = "_blank",
  rel = "noopener noreferrer",
  ...props
}) {
  return <Link to={to} target={target} rel={rel} {...props} />;
}

export default ExternalTabLink;
